/**
 * Generated by orval v7.8.0 🍺
 * Do not edit manually.
 * TopTopTime API
 * <:3 )~~~~    =^.^=
 * OpenAPI spec version: 0.0.1
 */

/**
 * Resolution decision: accepted (refund user) or rejected (professional keeps money)
 */
export enum ResolveDisputeBodyResolution {
  accepted = 'accepted',
  rejected = 'rejected'
}
